import React, { useState, useRef, useEffect } from 'react';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import { isMobileWeb } from '../../../../../../../../utils';

function calculateSecondsUntilTarget(timerDeadlineValue) {
  // Convert the target date string to a Date object
  const targetDate = new Date(timerDeadlineValue);

  // Get the current date and time
  const currentDate = new Date();

  // Calculate the difference in milliseconds
  const differenceInMillis = targetDate.getTime() - currentDate.getTime();

  // Convert milliseconds to seconds
  return Math.floor(differenceInMillis / 1000);
}

const Timer = ({ setDefaultBannerAction, timerDeadlineValue }) => {
  const Ref = useRef(null);
  const secondsUntilDeadline = calculateSecondsUntilTarget(timerDeadlineValue);

  const formatTime = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (isMobileWeb()) {
      return (
        <div className="timer-wrapper-mobile">
          <div className="timer-wrapper">
            <BodyCopy
              fontSize="fs18"
              component="span"
              fontFamily="secondary"
              fontWeight={['bold']}
              className="timer-text"
            >
              {hours < 10 ? `0${hours}` : hours}
            </BodyCopy>
            <BodyCopy
              fontSize="fs8"
              component="span"
              fontFamily="secondary"
              fontWeight={['bold']}
              className="timer-text"
            >
              Hrs
            </BodyCopy>
          </div>
          <BodyCopy
            fontSize="fs18"
            component="span"
            fontFamily="secondary"
            fontWeight={['bold']}
            className="timer-text"
          >
            :
          </BodyCopy>
          <div className="timer-wrapper">
            <BodyCopy
              fontSize="fs18"
              component="span"
              fontFamily="secondary"
              fontWeight={['bold']}
              className="timer-text"
            >
              {minutes < 10 ? `0${minutes}` : minutes}
            </BodyCopy>
            <BodyCopy
              fontSize="fs8"
              component="span"
              fontFamily="secondary"
              fontWeight={['bold']}
              className="timer-text"
            >
              Mins
            </BodyCopy>
          </div>
          <BodyCopy
            fontSize="fs18"
            component="span"
            fontFamily="secondary"
            fontWeight={['bold']}
            className="timer-text"
          >
            :
          </BodyCopy>
          <div className="timer-wrapper">
            <BodyCopy
              fontSize="fs18"
              component="span"
              fontFamily="secondary"
              fontWeight={['bold']}
              className="timer-text"
            >
              {seconds < 10 ? `0${seconds}` : seconds}
            </BodyCopy>
            <BodyCopy
              fontSize="fs8"
              component="span"
              fontFamily="secondary"
              fontWeight={['bold']}
              className="timer-text"
            >
              Secs
            </BodyCopy>
          </div>
        </div>
      );
    }
    return (
      <span>
        <BodyCopy
          fontSize="fs20"
          component="span"
          fontFamily="secondary"
          fontWeight={['bold']}
          className="timer-text"
        >
          {hours < 10 ? `0${hours}` : hours}
        </BodyCopy>{' '}
        <BodyCopy
          fontSize="fs10"
          component="span"
          fontFamily="secondary"
          fontWeight={['bold']}
          className="timer-text"
        >
          Hrs
        </BodyCopy>{' '}
        <BodyCopy
          fontSize="fs20"
          component="span"
          fontFamily="secondary"
          fontWeight={['bold']}
          className="timer-text"
        >
          :
        </BodyCopy>{' '}
        <BodyCopy
          fontSize="fs20"
          component="span"
          fontFamily="secondary"
          fontWeight={['bold']}
          className="timer-text"
        >
          {minutes < 10 ? `0${minutes}` : minutes}
        </BodyCopy>{' '}
        <BodyCopy
          fontSize="fs10"
          component="span"
          fontFamily="secondary"
          fontWeight={['bold']}
          className="timer-text"
        >
          Mins
        </BodyCopy>{' '}
        <BodyCopy
          fontSize="fs20"
          component="span"
          fontFamily="secondary"
          fontWeight={['bold']}
          className="timer-text"
        >
          :
        </BodyCopy>{' '}
        <BodyCopy
          fontSize="fs20"
          component="span"
          fontFamily="secondary"
          fontWeight={['bold']}
          className="timer-text"
        >
          {seconds < 10 ? `0${seconds}` : seconds}
        </BodyCopy>{' '}
        <BodyCopy
          fontSize="fs10"
          component="span"
          fontFamily="secondary"
          fontWeight={['bold']}
          className="timer-text"
        >
          Secs
        </BodyCopy>
      </span>
    );
  };

  const [timer, setTimer] = useState(formatTime(secondsUntilDeadline));

  const getTimeRemaining = (deadline) => {
    const TIME_ZONE = 'America/New_York';
    const deadlineDate = new Date(deadline);
    const currentTime = new Date();
    const currentTimeEST = new Date(currentTime?.toLocaleString('en-US', { timeZone: TIME_ZONE }));
    const total = Math.floor((deadlineDate - currentTimeEST) / 1000);

    const hours = Math.floor(total / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;
    return {
      total,
      hours,
      minutes,
      seconds,
    };
  };

  const startTimer = (deadline) => {
    const updateTimer = () => {
      const { total } = getTimeRemaining(deadline);
      if (total >= 0) {
        setTimer(formatTime(total));
      } else {
        setTimer(
          <span>
            <BodyCopy
              fontSize="fs20"
              component="span"
              fontFamily="secondary"
              fontWeight={['bold']}
              className="timer-text"
            >
              00
            </BodyCopy>{' '}
            <BodyCopy
              fontSize="fs10"
              component="span"
              fontFamily="secondary"
              fontWeight={['bold']}
              className="timer-text"
            >
              Hrs
            </BodyCopy>{' '}
            <BodyCopy
              fontSize="fs20"
              component="span"
              fontFamily="secondary"
              fontWeight={['bold']}
              className="timer-text"
            >
              :
            </BodyCopy>{' '}
            <BodyCopy
              fontSize="fs20"
              component="span"
              fontFamily="secondary"
              fontWeight={['bold']}
              className="timer-text"
            >
              00
            </BodyCopy>{' '}
            <BodyCopy
              fontSize="fs10"
              component="span"
              fontFamily="secondary"
              fontWeight={['bold']}
              className="timer-text"
            >
              Mins
            </BodyCopy>{' '}
            <BodyCopy
              fontSize="fs20"
              component="span"
              fontFamily="secondary"
              fontWeight={['bold']}
              className="timer-text"
            >
              :
            </BodyCopy>{' '}
            <BodyCopy
              fontSize="fs20"
              component="span"
              fontFamily="secondary"
              fontWeight={['bold']}
              className="timer-text"
            >
              00
            </BodyCopy>{' '}
            <BodyCopy
              fontSize="fs10"
              component="span"
              fontFamily="secondary"
              fontWeight={['bold']}
              className="timer-text"
            >
              Secs
            </BodyCopy>
          </span>
        );
        clearInterval(Ref.current);
        setDefaultBannerAction(true);
      }
    };

    updateTimer();

    const id = setInterval(updateTimer, 1000);
    Ref.current = id;
  };

  const clearTimer = () => {
    if (Ref.current) clearInterval(Ref.current);
  };

  const getDeadline = () => {
    const storedDeadline = timerDeadlineValue;
    if (storedDeadline) {
      return new Date(storedDeadline);
    }
    const deadline = new Date();
    deadline.setSeconds(deadline.getSeconds() + secondsUntilDeadline);
    return deadline;
  };

  useEffect(() => {
    clearTimer();
    const deadline = getDeadline();
    startTimer(deadline);
  }, []);

  return <div>{timer}</div>;
};

export default Timer;
